export default "/_next/static/images/bd4d9afa98e7fac267c4dd3054c39153.jpg";